import { render, staticRenderFns } from "./appointmentList.vue?vue&type=template&id=0765bb10&"
import script from "./appointmentList.vue?vue&type=script&lang=js&"
export * from "./appointmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0765bb10')) {
      api.createRecord('0765bb10', component.options)
    } else {
      api.reload('0765bb10', component.options)
    }
    module.hot.accept("./appointmentList.vue?vue&type=template&id=0765bb10&", function () {
      api.rerender('0765bb10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/appointments/components/appointmentList.vue"
export default component.exports